import React from 'react';

import { If } from 'utils';
import { UiKit } from 'components';

export default function ReasonBody({
  data,
  dispatch,
  state: { reason, otherReason, otherReasonInvalid, options }
}) {
  let isSelectActive =
    data.type === 'cancel' ||
    (data.type === 'hold' && data.extra && data.extra.holdVal);

  const onReasonChange = reason => {
    dispatch({ type: 'handleReasonChange', val: reason });
  };

  const onOtherReasonTextChange = value => {
    dispatch({ type: 'handleInputChange', val: value });
  };

  return (
    <UiKit.Grid templateColumns="1fr" gap="16" className="mt-3">
      <If test={isSelectActive}>
        <UiKit.Select
          label="Select Reason"
          value={reason}
          options={options}
          onChange={onReasonChange}
        />
      </If>
      <If test={reason.value === 'other' || !isSelectActive}>
        <UiKit.Textarea
          autoFocus
          label="Tell us more about it"
          caption="Reason must be atleast 10 characters in length."
          value={otherReason}
          onChange={onOtherReasonTextChange}
          error={otherReasonInvalid}
        />
      </If>
    </UiKit.Grid>
  );
}
